"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontStyleEnum = void 0;
var FontStyleEnum;
(function (FontStyleEnum) {
    FontStyleEnum["Italic"] = "italic";
    FontStyleEnum["Bold"] = "bold";
    FontStyleEnum["BoldItalic"] = "bold-italic";
})(FontStyleEnum = exports.FontStyleEnum || (exports.FontStyleEnum = {}));
